<div class="row mb-4" [hidden]="hidden" [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label" [style]="field.isTitle?{'text-align': 'center' , 'font-size':'16px'} : null">
        {{field.label}}
    </label>

    <div class="col-sm-10">

        <label class="pt-2">
            {{value}}
        </label>

    </div>

    <p class="pt-1 text-danger" style="font-size: 13px !important;" *ngIf="yourTurn && field?.approved == false">
        {{field.comment}}
    </p>
    
</div>